module.exports = __webpack_public_path__ + "static/img/board_mode.6830d2bf.png";